"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioContext = void 0;
var react_1 = require("react");
exports.RadioContext = (0, react_1.createContext)({
    selected: undefined,
    onChange: function () { return undefined; },
    disabled: false,
});
//# sourceMappingURL=context.js.map